import { MessagesSquare } from "@tamagui/lucide-icons";
import { useContext } from "react";
import { View, XStack, YStack, useTheme } from "tamagui";

import { medicalGroupName } from "@/config/brand";
import { LayoutContext } from "./LayoutProvider";
import { Heading, Text } from "./Typography";

type OutreachNoteProps = {
  title: string;
  message: string;
};

export default function OutreachNote({ title, message }: OutreachNoteProps) {
  const theme = useTheme();
  const { headerHeight } = useContext(LayoutContext);

  return (
    <YStack gap="$100" marginTop={headerHeight.current}>
      <Text conversational>
        You have an update from {medicalGroupName}. Here is what was shared:
      </Text>
      <XStack
        gap="$200"
        padding="$300"
        borderRadius="$150"
        marginVertical="$200"
        outlineWidth={2}
        outlineColor="$strokeNeutral"
        outlineStyle="solid"
      >
        <View flexShrink={0} flexGrow={0}>
          <MessagesSquare color={theme.iconBase.get()} />
        </View>
        <YStack flex={1}>
          <Heading size="$md" marginBottom="$50">
            {title}
          </Heading>
          <Text>{message}</Text>
        </YStack>
      </XStack>
      <Text conversational>
        Would you like me to help you send any questions back to the clinical
        team, or would you like to go over next steps together with me?
      </Text>
    </YStack>
  );
}
